import TemplateElementFactory from './TemplateElementFactory';

export default {
  __init__: [
    'templateElementFactory'
  ],
  templateElementFactory: [ 'type', TemplateElementFactory ]
};
